module.exports = __webpack_public_path__ + "img/senalando-izqni.png.c15186c4.webp";